import * as t from 'io-ts';

export enum Activity {
  Error     = 'error',
  Initial   = 'initial',
  Recording = 'recording',
  Uploading = 'uploading',
  Recorded  = 'recorded',
}

export enum ClipErrorCode {
  InternalError = 'Clip.InternalError',
  UploadError   = 'Clip.UploadError',
}

export enum RecStopReason {
  MediaChange = 'mediaChange',
  Timeout     = 'timeout',
  UserRequest = 'userRequest',
}

export enum SceneName {
  ClipPlayback = 'clipPlayback',
  Idle = 'owlTest', // TODO: This is a workaround for bandwidth estimation issues, revert me!
  OwlTest = 'owlTest',
  SimpleTest = 'simpleTest',
  VideoPlayer = 'videoPlayer', // Commands bot to play a video file
  Echo = 'echo',
}

export interface IClip {
  activity: Activity;
  audioRecReady: boolean;
  errorCode?: ClipErrorCode;
  errorDetail?: string;
  recStopReason?: RecStopReason;
  uploadedUrl?: string;
  videoRecReady: boolean;
}

export interface IScene {
  isPlaying: boolean;
  sceneName: SceneName;
}

export interface IBotLaunchMeta {
  launch_id?: string;
}

export const BotLaunchMeta: t.Type<IBotLaunchMeta> = t.partial({
  launch_id: t.string,
});

export interface IBotState {
  clip: IClip;
  scene: IScene;
}
